import { combineReducers } from 'redux';
import alert from './alert';
import authentication from './auth';

/**
 *
 * Combine all reducers in this file and export the combined reducers.
 *
 * @return {object} combined reducers
 */
const createReducer = () => combineReducers({ authentication, alert });

export default createReducer;



// WEBPACK FOOTER //
// ./src/core/reducers.js